<template>
  <VueDraggableResizable
    :w="w"
    :h="h"
    :x="x"
    :y="y"
    :draggable="!isMobile"
    :resizable="!isMobile"
    class-name="section-layout__wrapper"
    drag-cancel=".drag-cancel"
    parent="#app"
    @dragging="onDrag"
    @resizing="onResize"
  >
    <div
      class="section-layout"
      :class="{ dark }"
    >
      <div
        class="section-layout__header"
        :class="{ dark, hidden: !dark }"
      >
        <slot name="header" />
      </div>
      <div
        class="section-layout__main drag-cancel"
        :class="{ dark }"
      >
        <slot />
      </div>
      <div
        v-if="dark"
        class="section-layout__footer"
      >
        <slot name="footer" />
      </div>
    </div>
  </VueDraggableResizable>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import VueDraggableResizable from 'vue-draggable-resizable'

export default {
  name: 'SectionLayout',

  components: {
    VueDraggableResizable,
  },

  computed: {
    ...mapGetters({
      isMobile: 'global/isMobile',
      x: 'global/sectionX',
      y: 'global/sectionY',
      w: 'global/sectionWidth',
      h: 'global/sectionHeight',
    }),

    ...mapState({
      dark: state => state.auth.dark,
    }),
  },

  methods: {
    ...mapActions({
      dragElement: 'global/dragElement',
    }),

    onResize(x, y, width, height) {
      this.dragElement({
        x,
        y,
        height,
        width,
      })
    },

    onDrag(x, y) {
      this.dragElement({
        x,
        y,
        height: this.h,
        width: this.w,
      })
    },
  },
}
</script>

<style lang="postcss" scoped>
.section-layout {
  @apply w-full flex flex-col h-full bg-blue-darkest p-2;

  &__wrapper {
    z-index: 9 !important;
  }

  &.dark {
    @apply border border-blue bg-dark-black;
  }

  &__header {
    height: 80px;
    @apply px-4 py-2 uppercase overflow-hidden;

    &.dark {
      height: 50px;
      @apply bg-dark-black;
    }
  }

  &__main {
    @apply bg-blue-darker overflow-y-scroll relative flex-1;

    &.dark {
      @apply bg-dark-black p-4;
    }
  }

  &__footer {
    height: 90px;
    @apply flex justify-end items-end pr-6 pb-4 bg-dark-black;
  }
}

@screen sm {
  .section-layout {
    &__header {
      @apply block;
    }
  }
}
</style>
